'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _channelProfile = require('../actions/channel-profile');

var Actions = _interopRequireWildcard(_channelProfile);

var _groupsHelper = require('../../helpers/groups-helper');

var groupsHelper = _interopRequireWildcard(_groupsHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { data: {}, isFetching: 0 };
    var action = arguments[1];

    switch (action.type) {
        // ---------------------------------------------------------------------CHANNELS-------------------------------------------------------------------

        case Actions.GET_CHANNELS_START:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching + 1
                });
            }

        case Actions.GET_CHANNELS_COMPLETE:
            {
                return _extends({}, state, {
                    channels: action.channels,
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.GET_CHANNELS_FAILURE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1,
                    error: action.error
                });
            }

        // ---------------------------------------------------------------------CHANNEL PROFILE-------------------------------------------------------------------

        case Actions.GET_CHANNEL_PROFILE_START:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching + 1
                });
            }

        case Actions.GET_CHANNEL_PROFILE_COMPLETE:
            {
                return _extends({}, state, {
                    channel: action.response,
                    isFetching: state.isFetching - 1
                });
            }
        case Actions.UNAUTH_CHANNEL_PROFILE_RESOLVE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.GET_CHANNEL_PROFILE_FAILURE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.POST_TO_CHANNEL_PROFILE_COMPLETE:
            {
                var newChannelProfile = Object.assign({}, state.channel);
                newChannelProfile.groupKeys ? newChannelProfile.groupKeys : newChannelProfile.groupKeys = [];
                var newOrderGroupData = [].concat(_toConsumableArray(state.groupData));

                if (action.channelBanner || action.channelBanner === false) {
                    newChannelProfile.channelBannerCdn = action.channelBanner;
                    newChannelProfile.channelBanner = action.channelBanner;
                }
                action.channelTheme ? newChannelProfile.channelTheme = action.channelTheme : null;
                action.channelThemeTextColor ? newChannelProfile.channelThemeTextColor = action.channelThemeTextColor : null;
                action.channelTitle ? newChannelProfile.channelTitle = action.channelTitle : null;
                action.channelDescription || action.channelDescription === '' ? newChannelProfile.channelDescription = action.channelDescription : null;
                if (action.channelLogo || action.channelLogo === false) {
                    newChannelProfile.channelLogoCdn = action.channelLogo;
                    newChannelProfile.channelLogo = action.channelLogo;
                }
                if (action.groupKeys) {
                    newChannelProfile.groupKeys = action.groupKeys;
                    newOrderGroupData = groupsHelper.sortGroupData(newOrderGroupData, action.groupKeys);
                }

                return _extends({}, state, {
                    groupData: newOrderGroupData,
                    channel: newChannelProfile
                });
            }

        case Actions.POST_TO_CHANNEL_PROFILE_FAILURE:
            {
                var errObj = void 0;

                if (state.error && state.error.isError === true) {
                    errObj = Object.assign({}, state.error);
                } else {
                    errObj = {
                        isError: true,
                        errorCode: action.error.status,
                        errorMessage: action.error.statusText,
                        dataCall: action.dataCall,
                        dataBody: action.body ? action.body : null
                    };
                }

                return _extends({}, state, {
                    error: errObj
                });
            }

        case Actions.CHANNEL_PROFILE_ERROR_HANDLED:
            {
                return _extends({}, state, {
                    error: {
                        isError: false,
                        errorCode: null,
                        errorMessage: null,
                        dataCall: null,
                        dataBody: null
                    }
                });
            }

        // ---------------------------------------------------------------------ALL CONTENT ID'S-------------------------------------------------------------------

        case Actions.GET_CONTENT_ID_LIST_START:
            {
                return _extends({}, state, {
                    channelContentIds: action.response,
                    isFetching: state.isFetching + 1
                });
            }

        case Actions.GET_CONTENT_ID_LIST_COMPLETE:
            {
                return _extends({}, state, {
                    channelContentIds: action.response,
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.GET_CONTENT_ID_LIST_FAILURE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1
                });
            }

        // ---------------------------------------------------------------------CONTENT FEATURE-------------------------------------------------------------------

        case Actions.GET_FEATURED_CONTENT_LIST_START:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching + 1
                });
            }

        case Actions.GET_FEATURED_CONTENT_LIST_COMPLETE:
            {
                return _extends({}, state, {
                    featured: action.response,
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.GET_FEATURED_CONTENT_LIST_FAILURE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.PUT_TO_FEATURE_CONTENT_START:
            {
                return _extends({}, state, {
                    featureDisable: true
                });
            }

        case Actions.PUT_TO_FEATURE_CONTENT_COMPLETE:
            {
                var updatedFeaturedList = state.featured.slice();
                updatedFeaturedList = action.status.feature ? updatedFeaturedList.concat(action.status.contentKey) : updatedFeaturedList.filter(function (item) {
                    return item !== action.status.contentKey;
                });

                return _extends({}, state, {
                    featured: updatedFeaturedList,
                    featureDisable: false
                });
            }

        case Actions.PUT_TO_FEATURE_CONTENT_FAILURE:
            {
                var _errObj = {};
                if (state.error && state.error.isError === true) {
                    _errObj = Object.assign({}, state.error);
                } else {
                    _errObj = {
                        isError: true,
                        errorCode: action.error.status,
                        errorMessage: action.error.statusText,
                        dataCall: action.dataCall,
                        dataBody: action.body
                    };
                }
                return _extends({}, state, {
                    featureDisable: false,
                    error: _errObj
                });
            }

        // ---------------------------------------------------------------------CHANNEL GROUPS-------------------------------------------------------------------

        // GROUP PUT
        case Actions.PUT_TO_CHANNEL_GROUP_START:
            {
                return _extends({}, state);
            }

        case Actions.PUT_TO_CHANNEL_GROUP_COMPLETE:
            {
                var newGroupData = [].concat(_toConsumableArray(state.groupData));
                var updateGroupIndex = newGroupData.findIndex(function (group) {
                    return group.groupKey === action.groupKey;
                });
                if (updateGroupIndex !== -1) {
                    newGroupData[updateGroupIndex].groupName = action.groupName;
                }
                return _extends({}, state, {
                    groupData: newGroupData
                });
            }

        // GROUP POST
        case Actions.POST_CHANNEL_GROUP_START:
            {
                return _extends({}, state);
            }

        case Actions.POST_CHANNEL_GROUP_COMPLETE:
            {
                var _newGroupData = void 0;
                var createdGroup = { groupKey: action.response.groupKey, groupName: action.groupName };
                var _newChannelProfile = Object.assign({}, state.channel);
                state.groupData ? _newGroupData = [].concat(_toConsumableArray(state.groupData)) : _newGroupData = [];
                _newChannelProfile.groupKeys ? _newChannelProfile.groupKeys : _newChannelProfile.groupKeys = [];
                action.response && action.response.groupKey ? _newChannelProfile.groupKeys.unshift(action.response.groupKey) : null;
                action.response && action.response.groupKey && action.groupName ? _newGroupData.unshift(createdGroup) : null;
                return _extends({}, state, {
                    groupData: _newGroupData,
                    channel: _newChannelProfile
                });
            }

        case Actions.POST_CHANNEL_GROUP_FAILURE:
            {
                var _errObj2 = {};
                if (state.error && state.error.isError === true) {
                    _errObj2 = Object.assign({}, state.error);
                } else {
                    _errObj2 = {
                        isError: true,
                        errorCode: action.error.status,
                        errorMessage: action.error.body,
                        dataCall: action.dataCall,
                        dataBody: action.error.body ? action.error.body : null
                    };
                }
                return _extends({}, state, {
                    error: _errObj2
                });
            }
        // GROUP MOVE TO NEW GROUP
        case Actions.PUT_TO_MOVE_CONTENT_NEW_GROUP_START:
            {
                return _extends({}, state, {
                    groupData: action.groupData
                });
            }

        case Actions.PUT_TO_MOVE_CONTENT_NEW_GROUP_COMPLETE:
            {
                return _extends({}, state);
            }

        case Actions.PUT_TO_MOVE_CONTENT_NEW_GROUP_FAILURE:
            {
                var _errObj3 = void 0;

                if (state.error && state.error.isError === true) {
                    _errObj3 = Object.assign({}, state.error);
                } else {
                    _errObj3 = {
                        isError: true,
                        errorCode: action.error.status,
                        errorMessage: action.error.statusText,
                        dataCall: action.dataCall,
                        dataBody: action.error.body ? action.error.body : null
                    };
                }

                return _extends({}, state, {
                    groupData: action.groupData,
                    error: _errObj3
                });
            }

        // GROUP MOVE WITHIN GROUP
        case Actions.PUT_TO_MOVE_CONTENT_WITHIN_GROUP_START:
            {
                return _extends({}, state, {
                    groupData: action.groupData
                });
            }

        case Actions.PUT_TO_MOVE_CONTENT_WITHIN_GROUP_COMPLETE:
            {
                return _extends({}, state);
            }

        case Actions.PUT_TO_MOVE_CONTENT_WITHIN_GROUP_FAILURE:
            {
                var _errObj4 = void 0;

                if (state.error && state.error.isError === true) {
                    _errObj4 = Object.assign({}, state.error);
                } else {
                    _errObj4 = {
                        isError: true,
                        errorCode: action.error.status,
                        errorMessage: action.error.statusText,
                        dataCall: action.dataCall,
                        dataBody: action.error.body ? action.error.body : null
                    };
                }

                return _extends({}, state, {
                    groupData: action.groupData,
                    error: _errObj4
                });
            }
        // MOVING MULTIPLE CONTENTS TO ANOTHER GROUP
        case Actions.MOVE_CONTENTS_ANOTHER_GROUP_START:
            {
                return _extends({}, state, {
                    groupData: action.groupData
                });
            }

        case Actions.MOVE_CONTENTS_ANOTHER_GROUP_COMPLETE:
            {
                return _extends({}, state);
            }

        // GROUP ADD (COPY)
        case Actions.PUT_TO_ADD_CONTENT_START:
            {
                return _extends({}, state);
            }

        case Actions.PUT_TO_ADD_CONTENT_COMPLETE:
            {
                return _extends({}, state, {
                    groupData: action.groupData
                });
            }

        case Actions.PUT_TO_ADD_CONTENT_FAILURE:
            {
                var _errObj5 = void 0;

                if (state.error && state.error.isError === true) {
                    _errObj5 = Object.assign({}, state.error);
                } else {
                    _errObj5 = {
                        isError: true,
                        errorCode: action.error.status,
                        errorMessage: action.error.statusText,
                        dataCall: action.dataCall,
                        dataBody: action.error.body ? action.error.body : null
                    };
                }

                return _extends({}, state, {
                    error: _errObj5
                });
            }

        // GROUP DELETE
        case Actions.DELETE_CHANNEL_GROUP_START:
            {
                return _extends({}, state);
            }

        case Actions.DELETE_CHANNEL_GROUP_COMPLETE:
            {
                var _newGroupData2 = [].concat(_toConsumableArray(state.groupData));
                var _newChannelProfile2 = Object.assign({}, state.channel);
                var deleteKeyIndex = _newChannelProfile2.groupKeys.findIndex(function (groupKey) {
                    return groupKey === action.groupKey;
                });
                if (deleteKeyIndex !== -1) {
                    _newChannelProfile2.groupKeys.splice(deleteKeyIndex, 1);
                }
                var deleteGroupIndex = _newGroupData2.findIndex(function (group) {
                    return group.groupKey === action.groupKey;
                });
                if (deleteGroupIndex !== -1) {
                    _newGroupData2.splice(deleteGroupIndex, 1);
                }
                return _extends({}, state, {
                    groupData: _newGroupData2,
                    channel: _newChannelProfile2
                });
            }

        // GROUP GET
        case Actions.GET_CHANNEL_GROUP_DATA_START:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching + 1
                });
            }

        case Actions.GET_CHANNEL_GROUP_DATA_COMPLETE:
            {
                return _extends({}, state, {
                    groupData: action.response,
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.GET_CHANNEL_GROUP_DATA_FAILURE:
            {
                return _extends({}, state, {
                    isFetching: state.isFetching - 1
                });
            }

        case Actions.RESET_CHANNEL_STATE:
            {
                return {
                    data: {},
                    isFetching: 0
                };
            }

        case Actions.SET_LIMITED_AUDIENCE_COMPLETE:
            {
                var updatedChannelProfile = Object.assign({}, state.channel);
                updatedChannelProfile.isLimitedAudience = action.isLimitedAudience;
                return _extends({}, state, {
                    channel: updatedChannelProfile
                });
            }
        // ---------------------------------------------------------------------CHANNEL PROFILE-------------------------------------------------------------------

        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/channel-profile.js
// module id = 765
// module chunks = 0